import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchGetCandAttente(action) {
	try {
		const result = yield fromApi.candidatsAttenteGet(action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_CANDATTENTE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetCandidat(action) {
	try {
		const result = yield fromApi.candidatGet(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_CANDIDAT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutCandidat(action) {
	try {
		const result = yield fromApi.candidatPut(action.payload, action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_CANDIDAT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchDelCandidat(action) {
	try {
		const result = yield fromApi.candidatDel(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DEL_CANDIDAT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* tremplinscandidat() {
	yield takeLatest('GET_CANDATTENTE_SAGAS', watchGetCandAttente);
	yield takeLatest('GET_CANDIDAT_SAGAS', watchGetCandidat);
	yield takeLatest('PUT_CANDIDAT_SAGAS', watchPutCandidat);
	yield takeLatest('DEL_CANDIDAT_SAGAS', watchDelCandidat);
}

export default function* rootSaga() {
	yield all([tremplinscandidat()]);
}
